import BaseStore from '../../BaseStore';
import TicketModel from "../../../models/Maintenance/Ticket/TicketModel";
import { observable, action, computed, toJS } from 'mobx';
import moment from "moment/moment";
import { token } from "../../../libs/localStorage";
import { random_rgba } from "../../../utils";
import _ from "lodash";

class TicketStore extends BaseStore {
  stationStore;
  ticketStatusStore;
  ticketReasonStore;
  ticketActionStore;
  userStore;
  locationStore;

  viewByOptions = [{ id: 1, name: 'Status' }, { id: 2, name: 'Reason' }, { id: 3, name: 'Action' }, { id: 4, name: 'Assigned to' }, { id: 5, name: 'Assigned by' }];

  @observable viewBy = 1;
  @observable show = null;
  @observable selectedMarker = null;
  @observable searchTags = [];

  @observable ticket_logs = [];
  @observable followers = [];
  @observable ticket = null;
  @observable view_archived = false;
  @observable assigned_to_all = false;
  @observable assigned_to_all_trip = false;
  @observable multiTagOptions = [];
  @observable filters = {
    date_from: null,
    date_to: null,
    filter_by_location: false,
    location_id: 0,
    location_type_id: 0,
    open_duration: {
      from: null,
      to: null,
    },
  }
  @observable selectedStations = [];

  @observable checkedTicketIds = [];
  @observable allChecked = false;

  @action onChangeTicketSelect = (t) => {
    if (this.checkedTicketIds.includes(t.id)) {
      this.checkedTicketIds = this.checkedTicketIds.filter(item => item !== t.id);
    } else {
      this.checkedTicketIds.push(t.id);
    }
    this.allChecked = false;
  };

  @action onChangeTicketSelectAll = () => {
    this.allChecked = !this.allChecked;
    if (this.allChecked) {
      this.checkedTicketIds = this.filteredTickets.map(item => item.id);
    } else {
      this.checkedTicketIds = [];
    }
  };

  @action onChangeFilters = (key, e) => {
    this.filters[key] = e.target.value;
    if (key === 'location_type_id') this.filters.location_id = 0;
    this.selectedMarker = null;
  }
  @action onChangeSelectedStations = items => {
    this.selectedStations = items;
    this.selectedMarker = null;
  }

  constructor({
    stationStore,
    ticketStatusStore,
    ticketReasonStore,
    ticketActionStore,
    userStore,
    locationStore,
    transportLayer
  }) {
    super(TicketModel, transportLayer);

    this.stationStore = stationStore;
    this.ticketStatusStore = ticketStatusStore;
    this.ticketReasonStore = ticketReasonStore;
    this.ticketActionStore = ticketActionStore;
    this.userStore = userStore;
    this.locationStore = locationStore;
  }

  @action setMultiTagOptions = (multiTagOptions) => {
    this.multiTagOptions = multiTagOptions;
  };

  @action onChangeSearchTags = tags => {
    this.selectedMarker = null;
    this.searchTags = tags;
  }

  @action onChangeViewBy = value => {
    this.viewBy = value;
    this.show = null;
  };
  @action onChangeShow = value => {
    if (value === this.show) this.show = null;
    else this.show = value;
  };

  @action onMarkerOver = marker => this.selectedMarker = marker.station_id;

  getMarkers = () => {
    const statusItems = this.ticketStatusStore.items,
      reasonItems = this.ticketReasonStore.items,
      actionItems = this.ticketActionStore.items,
      ticketItems = this.filteredTickets,
      users = this.userStore.items;

    let stations = _.groupBy(ticketItems, item => item.station_id);
    return Object.keys(stations).map(station_id => {
      let station = this.stationStore.findById(station_id);
      let tickets = stations[station_id]
        .map(ticket => {
          let status = statusItems.find(item => +item.id === +ticket.status_id),
            reason = reasonItems.find(item => +item.id === +ticket.reason_id),
            user = users.find(item => +item.id === +ticket.assigned_to),
            action = actionItems.find(item => +item.id === +ticket.action_id);

          const color = +this.viewBy === 4 ? ticket.assigneeColor : ticket.userColor;

          return Object.assign({}, ticket.asJson, { status, reason, action, color, user })
        });

      let color = '';

      switch (+this.viewBy) {
        case 1: color = !!this.show ? _.result(tickets.find(item => +item.status_id === +this.show), 'status.color', '') : _.result(tickets, '[0].status.color'); break;
        case 2: color = !!this.show ? _.result(tickets.find(item => +item.reason_id === +this.show), 'reason.color', '') : _.result(tickets, '[0].reason.color'); break;
        case 3: color = !!this.show ? _.result(tickets.find(item => +item.action_id === +this.show), 'action.color', '') : _.result(tickets, '[0].action.color'); break;
        case 4: color = !!this.show ? _.result(tickets.find(item => +item.assigned_to === +this.show), 'color', '') : _.result(tickets, '[0].color'); break;
        case 5: color = !!this.show ? _.result(tickets.find(item => +item.user_id === +this.show), 'color', '') : _.result(tickets, '[0].color'); break;
        default: color = ''; break;
      }

      return (Object.assign(station, {
        station_id,
        station_name: station.name,
        tickets,
        color,
        duration: ''
      }));
    });
  }

   getMarkers2 = (tickets) => {
    const statusItems = this.ticketStatusStore.items,
      reasonItems = this.ticketReasonStore.items,
      actionItems = this.ticketActionStore.items,
      ticketItems = tickets || this.filteredTickets2,
      users = this.userStore.items;

    let stations = _.groupBy(ticketItems, item => item.station_id);
    return Object.keys(stations).map(station_id => {
      let station = this.stationStore.findById(station_id);
      let tickets = stations[station_id]
        .map(ticket => {
          let status = statusItems.find(item => +item.id === +ticket.status_id),
            reason = reasonItems.find(item => +item.id === +ticket.reason_id),
            user = users.find(item => +item.id === +ticket.assigned_to),
            action = actionItems.find(item => +item.id === +ticket.action_id);

          const color = +this.viewBy === 4 ? ticket.assigneeColor : ticket.userColor;

          return Object.assign({}, ticket.asJson, { status, reason, action, color, user })
        });

      let color = '';

      switch (+this.viewBy) {
        case 1: color = !!this.show ? _.result(tickets.find(item => +item.status_id === +this.show), 'status.color', '') : _.result(tickets, '[0].status.color'); break;
        case 2: color = !!this.show ? _.result(tickets.find(item => +item.reason_id === +this.show), 'reason.color', '') : _.result(tickets, '[0].reason.color'); break;
        case 3: color = !!this.show ? _.result(tickets.find(item => +item.action_id === +this.show), 'action.color', '') : _.result(tickets, '[0].action.color'); break;
        case 4: color = !!this.show ? _.result(tickets.find(item => +item.assigned_to === +this.show), 'color', '') : _.result(tickets, '[0].color'); break;
        case 5: color = !!this.show ? _.result(tickets.find(item => +item.user_id === +this.show), 'color', '') : _.result(tickets, '[0].color'); break;
        default: color = ''; break;
      }

      return (Object.assign(station, {
        station_id,
        station_name: station.name,
        tickets,
        color,
        duration: ''
      }));
    });
  }

  @computed get infoTableColumn() {
    switch (+this.viewBy) {
      case 1: return [{ key: 'color', label: '' }, { key: 'caption', label: 'Status' }, { key: 'number', label: '#' }];
      case 2: return [{ key: 'color', label: '' }, { key: 'caption', label: 'Reason' }, { key: 'number', label: '#' }];
      case 3: return [{ key: 'color', label: '' }, { key: 'caption', label: 'Action' }, { key: 'number', label: '#' }];
      case 4: return [{ key: 'color', label: '' }, { key: 'name', label: 'Assigned to' }, { key: 'number', label: '#' }];
      case 5: return [{ key: 'color', label: '' }, { key: 'name', label: 'Assigned by' }, { key: 'number', label: '#' }];
      default: return []
    }
  }

  @action onChangeViewSwitch(key) {
    this[key] = !this[key];
  };

   @action onChangeViewSwitch2(key) {
    this[key] = !this[key];
  };

  @computed get filteredTickets() {
    const tickets = this.items.reduce((acc, ticket) => {
      if (!this.view_archived && ticket.archived) return acc;
      if (!this.assigned_to_all && (+ticket.last_log.assigned_to || +ticket.assigned_to) !== +token.getDecoded().id) return acc;

      if (!!this.filters.date_from) {
        if (!this.filters.date_to && !moment(ticket.generated_date).isSameOrAfter(this.filters.date_from)) return acc;
        if (!!this.filters.date_to && !moment(ticket.generated_date).isBetween(this.filters.date_from, moment(this.filters.date_to).add(1, 'days'))) return acc;
      }

      const { open_duration: { from, to } } = this.filters;
      if (!!from && !!to) {
        if (!(ticket.open_duration >= from && ticket.open_duration <= to + 24 * 60 * 60 * 1000)) return acc;
      } else if (!from && !!to) {
        if (ticket.open_duration >= to) return acc;
      } else if (!!from && !to) {
        if (ticket.open_duration <= from) return acc;
      }

      if (!this.filters.filter_by_location && !this.selectedStations.includes(+ticket.station_id)) return acc;
      if (this.filters.filter_by_location && this.filters.location_type_id !== 0 && this.filters.location_id !== 0) {
        const station = this.stationStore.findById(ticket.station_id);
        if (!this.locationStore.isPartOf(station.location_id, this.filters.location_id)) return acc;
      }

      // const station = this.stationStore.findById(ticket.station_id);
      // if (station && station.tags && station.tags.length) {
      //   if (!this.searchTags.find(searchTag => station.tags.find(tag => tag.name.includes(searchTag)))) {
      //     return acc;
      //   }
      // }

      if (!!this.viewBy && !!this.show) {
        switch (+this.viewBy) {
          case 1: if (+ticket.status_id !== +this.show) return acc; else break;
          case 2: if (+ticket.reason_id !== +this.show) return acc; else break;
          case 3: if (+ticket.action_id !== +this.show) return acc; else break;
          case 4: if (+ticket.assigned_to !== +this.show) return acc; else break;
          case 5: if (+ticket.user_id !== +this.show) return acc; else break;
          default: break;
        }
      }

      acc.push(ticket);

      return acc;
    }, []);

    if (+this.viewBy === 4) {
      tickets.forEach(ticket => {
        const existingTicketWithColor = tickets.find(w =>
          +w.assigned_to === +ticket.assigned_to &&
          w.assigneeColor);

        if (existingTicketWithColor)
          ticket.assigneeColor = existingTicketWithColor.assigneeColor;
        else
          ticket.assigneeColor = random_rgba();
      });
    } else if (+this.viewBy === 5) {
      tickets.forEach(ticket => {
        const existingTicketWithColor = tickets.find(w =>
          +w.user_id === +ticket.user_id &&
          w.userColor);

        if (existingTicketWithColor)
          ticket.userColor = existingTicketWithColor.userColor;
        else
          ticket.userColor = random_rgba();
      });
    }

    return tickets;
  }

    @computed get filteredTickets2() {
    const tickets = this.items.reduce((acc, ticket) => {
      if (!this.view_archived && ticket.archived) return acc;
      if (!this.assigned_to_all_trip && (+ticket.last_log.assigned_to || +ticket.assigned_to) !== +token.getDecoded().id) return acc;

      // if (!!this.filters.date_from) {
      //   if (!this.filters.date_to && !moment(ticket.generated_date).isSameOrAfter(this.filters.date_from)) return acc;
      //   if (!!this.filters.date_to && !moment(ticket.generated_date).isBetween(this.filters.date_from, moment(this.filters.date_to).add(1, 'days'))) return acc;
      // }

      // const { open_duration: { from, to } } = this.filters;
      // if (!!from && !!to) {
      //   if (!(ticket.open_duration >= from && ticket.open_duration <= to + 24 * 60 * 60 * 1000)) return acc;
      // } else if (!from && !!to) {
      //   if (ticket.open_duration >= to) return acc;
      // } else if (!!from && !to) {
      //   if (ticket.open_duration <= from) return acc;
      // }

      // if (!this.filters.filter_by_location && !this.selectedStations.includes(+ticket.station_id)) return acc;
      // if (this.filters.filter_by_location && this.filters.location_type_id !== 0 && this.filters.location_id !== 0) {
      //   const station = this.stationStore.findById(ticket.station_id);
      //   if (!this.locationStore.isPartOf(station.location_id, this.filters.location_id)) return acc;
      // }

      // const station = this.stationStore.findById(ticket.station_id);
      // if (station && station.tags && station.tags.length) {
      //   if (!this.searchTags.find(searchTag => station.tags.find(tag => tag.name.includes(searchTag)))) {
      //     return acc;
      //   }
      // }

      if (!!this.viewBy && !!this.show) {
        switch (+this.viewBy) {
          case 1: if (+ticket.status_id !== +this.show) return acc; else break;
          case 2: if (+ticket.reason_id !== +this.show) return acc; else break;
          case 3: if (+ticket.action_id !== +this.show) return acc; else break;
          case 4: if (+ticket.assigned_to !== +this.show) return acc; else break;
          case 5: if (+ticket.user_id !== +this.show) return acc; else break;
          default: break;
        }
      }

      acc.push(ticket);

      return acc;
    }, []);

    if (+this.viewBy === 4) {
      tickets.forEach(ticket => {
        const existingTicketWithColor = tickets.find(w =>
          +w.assigned_to === +ticket.assigned_to &&
          w.assigneeColor);

        if (existingTicketWithColor)
          ticket.assigneeColor = existingTicketWithColor.assigneeColor;
        else
          ticket.assigneeColor = random_rgba();
      });
    } else if (+this.viewBy === 5) {
      tickets.forEach(ticket => {
        const existingTicketWithColor = tickets.find(w =>
          +w.user_id === +ticket.user_id &&
          w.userColor);

        if (existingTicketWithColor)
          ticket.userColor = existingTicketWithColor.userColor;
        else
          ticket.userColor = random_rgba();
      });
    }

    return tickets;
  }

  @computed get sortedTicketLogs() {
    return this.ticket_logs.sort((a, b) => new Date(a.log_date).valueOf() < new Date(b.log_date).valueOf() ? 1 : -1)
  }

  @computed get getCheckedFollowers() {
    return this.followers.filter(item => !!item.checked)
  }

  @computed get assignees() {
    return this.filteredTickets.reduce((acc, ticket) => {
      if (!ticket.assigned_to) return acc;
      const existingAssignee = acc.find(a => +a.id === +ticket.assigned_to);
      if (!existingAssignee) acc.push(Object.assign({}, ticket.assigned_to_user, { id: ticket.assigned_to, color: ticket.assigneeColor }));
      return acc;
    }, []);
  }

  @computed get assigners() {
    return this.filteredTickets.reduce((acc, ticket) => {
      if (!ticket.user_id) return acc;
      const existingAssigner = acc.find(a => +a.id === +ticket.user_id);
      if (!existingAssigner) acc.push(Object.assign({}, ticket.created_by_user, { id: ticket.user_id, color: ticket.userColor }));
      return acc;
    }, []);
  }

  fetchTicketById(id) {
    return this._fetchById(id).then(ticket => {
      this.ticket_logs = ticket.logs || [];
      this.followers = ticket.followers ? Object.assign(ticket.followers, { checked: false }) : [];
      delete ticket.logs;
      delete ticket.followers;
      this.ticket = ticket;
      this.updateItemFromServer(ticket);
    })
  }

  @action addTicketFollower(ticket_id, { user_id, name, email }) {
    this.transportLayer.follower.create(ticket_id, { user_id }).then(() => {
      this.followers.push({
        ticket_id,
        user_id,
        name,
        email
      })
    })
  }

  @action pushLog(log, file) {
    log.attachment_file = file;
    log.text = log.message.text;
    delete log.message;
    this.ticket_logs.push(log)
  }

  @action removeTicketFollower(ticket_id, user_id) {
    this.transportLayer.follower.remove(ticket_id, user_id).then(() => {
      this.followers = this.followers.filter(item => +item.ticket_id !== +ticket_id || +item.user_id !== +user_id)
    })
  }

  @action clearTicketView() {
    this.ticket_logs = [];
    this.followers = [];
    this.ticket = null;
  }

  getDuration = (then, dur) => {
    let duration = null, unit = '';
    if (!dur && !then) return '';
    else if (!!dur && !then) duration = dur / 1000;
    else {
      then = moment(then).valueOf();
      let now = moment().valueOf();
      duration = (now - then) / 1000;
    }

    if (duration < 60) return 'just now';
    else {
      unit = 'minute';
      duration /= 60;
      if (duration < 60) {
        duration = Math.floor(duration);
        unit = 'minute';
      } else if (duration >= 60 && duration < 1440) {
        duration = Math.floor(duration / 60);
        unit = 'hour';
      } else if (duration >= 1440 && duration < 1440 * 7) {
        duration = Math.floor(duration / 1440);
        unit = 'day';
      } else if (duration >= 1440 * 7 && duration < 1440 * 30) {
        duration = Math.floor(duration / (1440 * 7));
        unit = 'week'
      }
      else if (duration >= 1440 * 30 && duration < 1440 * 365) {
        duration = Math.floor(duration / (1440 * 30));
        unit = 'month'
      }
      else if (duration >= 1440 * 365) {
        duration = Math.floor(duration / (1440 * 365));
        unit = 'year'
      }
    }
    if (duration === 1) return `a ${unit} ago`;
    else return `${duration} ${unit}s ago`
  };

  createItem(json) {
    this.isSaving = true;
    return this._create(json)
      .then(action((row) => {
        this.isSaving = false;
        // return this.fetchItems().then(() => row);
        const item = new this.Model(this, { ...json, id: +row.id });
        if (item.id) { this.items.push(item); }
        return row;
      })).catch(err => {
        this.isSaving = false;
        return Promise.reject(err);
      });
  }

}

export default TicketStore;



// WEBPACK FOOTER //
// ./src/stores/Maintenance/Ticket/TicketStore.js